import React, {
  useRef,
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";
import $ from "jquery";
import moment from "moment";
import "daterangepicker/daterangepicker.css";
import "daterangepicker";

// Use forwardRef to allow Teams.js to trigger reset
const DateRangePicker = forwardRef(({ onDateChange }, ref) => {
  const dateRangeRef = useRef(null);
  const [selectedRange, setSelectedRange] = useState("Filter"); // Initially show "Filter"
  const [showClearButton, setShowClearButton] = useState(false); // Hide "X" initially

  useEffect(() => {
    const dateRangeElement = dateRangeRef.current;

    $(dateRangeElement).daterangepicker(
      {
        opens: "right",
        locale: {
          format: "MM/DD/YYYY hh:mm A",
        },
        timePicker: true,
        timePickerIncrement: 15,
        timePicker24Hour: false,
        autoUpdateInput: false, // Prevent default text update
        startDate: moment().subtract(7, "days"),
        endDate: moment(),
        ranges: {
          Today: [moment(), moment()],
          Yesterday: [
            moment().subtract(1, "days"),
            moment().subtract(1, "days"),
          ],
          "Last 7 Days": [moment().subtract(6, "days"), moment()],
          "Last 30 Days": [moment().subtract(29, "days"), moment()],
        },
      },
      function (start, end) {
        const formattedRange = `${start.format(
          "MM/DD/YYYY hh:mm A"
        )} - ${end.format("MM/DD/YYYY hh:mm A")}`;
        setSelectedRange(formattedRange); // Update displayed range
        setShowClearButton(true); // Show "X" button
        onDateChange({
          startDate: start.toISOString(),
          endDate: end.toISOString(),
        });
      }
    );

    return () => {
      if ($(dateRangeElement).data("daterangepicker")) {
        $(dateRangeElement).data("daterangepicker").remove();
      }
    };
  }, [onDateChange]);

  // Expose reset function to Teams.js using forwardRef
  useImperativeHandle(ref, () => ({
    resetPicker: () => {
      setSelectedRange("Filter"); // Reset input box text
      setShowClearButton(false); // Hide "X" button
      $(dateRangeRef.current)
        .data("daterangepicker")
        .setStartDate(moment().subtract(7, "days"));
      $(dateRangeRef.current).data("daterangepicker").setEndDate(moment());
    },
  }));

  // Clear filter when "X" is clicked
  const clearFilter = () => {
    setSelectedRange("Filter"); // Reset text
    setShowClearButton(false); // Hide "X" button
    onDateChange({ startDate: "", endDate: "" }); // Reset state
  };

  return (
    <div
      style={{ position: "relative", display: "inline-block", width: "50%" }}
    >
      <label htmlFor="daterange">Select Date and Time Range</label>
      <input
        type="text"
        id="daterange"
        className="form-control w-100"
        ref={dateRangeRef}
        value={selectedRange} // Show selected range or "Filter"
        readOnly
      />
      {showClearButton && (
        <button
          type="button"
          onClick={clearFilter}
          style={{
            position: "absolute",
            right: "1px",
            height: "37px",
            width: "37px",
            top: "68%",
            borderColor: "1px solid #ced4da",
            borderRadius: "4px",
            transform: "translateY(-50%)",
            background: "#e9ecef",
            border: "none",
            fontSize: "16px",
            cursor: "pointer",
          }}
        >
          X
        </button>
      )}
    </div>
  );
});

export default DateRangePicker;
